import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type EditorEntryBlockedKind = "catalog_list" | "blueprint_off_route";

export type EditorEntryBlockedState = null | {
  kind: EditorEntryBlockedKind;
  message?: string;
};

const initialState = null as EditorEntryBlockedState;

const editorEntryBlockedSlice = createSlice({
  name: "editorEntryBlocked",
  initialState,
  reducers: {
    sparxsEditorEntryBlocked: (
      _state,
      action: PayloadAction<{ kind: EditorEntryBlockedKind; message?: string }>,
    ): EditorEntryBlockedState => ({
      kind: action.payload.kind,
      ...(action.payload.message != null && action.payload.message !== ""
        ? { message: action.payload.message }
        : {}),
    }),
  },
});

export const { sparxsEditorEntryBlocked } = editorEntryBlockedSlice.actions;

export default editorEntryBlockedSlice.reducer;

export const selectEditorEntryBlocked = (state: {
  editor: { editorEntryBlocked: EditorEntryBlockedState };
}): EditorEntryBlockedState => state.editor.editorEntryBlocked;
